import { styled } from '@mui/material/styles';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

/* NPM */
import { endOfQuarter, endOfWeek, startOfQuarter, startOfWeek } from 'date-fns';
import dayjs from 'dayjs';
import isBetweenPlugin from 'dayjs/plugin/isBetween';

/* React */
import React from 'react';

dayjs.extend(isBetweenPlugin);

const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) =>
        prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay'
})(({ dayIsBetween, isFirstDay, isLastDay }) => ({
    ...(dayIsBetween && {
        borderRadius: 0
    }),
    ...(isFirstDay && {
        borderBottomLeftRadius: '50%',
        borderTopLeftRadius: '50%'
    }),
    ...(isLastDay && {
        borderBottomRightRadius: '50%',
        borderTopRightRadius: '50%'
    })
}));

export const Day = (props) => {
    const { day, selectedDay, pickerType, ...other } = props;

    let start;
    let end;

    if (selectedDay == null) {
        return <PickersDay day={day} {...other} />;
    }

    switch (pickerType) {
        case 'week':
            start = startOfWeek(new Date(selectedDay));
            end = endOfWeek(new Date(selectedDay));
            break;
        case 'quarter':
            start = startOfQuarter(new Date(selectedDay));
            end = endOfQuarter(new Date(selectedDay));
            break;
        default:
            start = new Date();
            end = new Date();
            break;
    }

    const dayIsBetween = day.isBetween(start, end, null, '[]');
    const isFirstDay = day.isSame(start, 'day');
    const isLastDay = day.isSame(end, 'day');

    return (
        <CustomPickersDay
            {...other}
            day={dayjs(day)}
            sx={
                dayIsBetween
                    ? {
                          backgroundColor: 'background.calendarSelectedSection',
                          color: 'text.calendarSelectedSection',
                          fontWeight: 600,
                          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
                          '&.Mui-disabled:not(.Mui-selected)': {
                              color: 'text.calendarSelectedSectionDisabled',
                              fontWeight: 300
                          },
                          mx: 0,
                          px: 2.5
                      }
                    : {}
            }
            dayIsBetween={dayIsBetween}
            isFirstDay={isFirstDay}
            isLastDay={isLastDay}
        />
    );
};
